import { Button, Stack, Typography, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles(theme => ({
  pill: {
    color: theme.palette.content.primaryBlack1,
    cursor: 'pointer',
    borderRadius: 39,
    background: theme.palette.background.primaryGrey1,
    border: `1px solid ${theme.palette.border.primaryBlack3}`,
    padding: '4px 10px',
    height: 30,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

const SKILL_MATCH_QUALIFIED = 'SKILL_MATCH_QUALIFIED';
const SKILL_MATCH_NOT_QUALIFIED = 'SKILL_MATCH_NOT_QUALIFIED';

const Pill = ({
  status,
  reverseStatus,
  setSelected,
  selected,
  label,
  setFilterAPICode,
  FiltersMap,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <Button
      onClick={() => {
        setFilterAPICode(prev => {
          const dum = { ...prev };
          console.log(dum);
          delete dum?.[FiltersMap?.filter_codes?.[reverseStatus]];
          if (!dum[FiltersMap?.filter_codes?.[status]])
            dum[FiltersMap?.filter_codes?.[status]] = 1;
          else if (dum[FiltersMap?.filter_codes?.[status]])
            delete dum[FiltersMap?.filter_codes?.[status]];
          return dum;
        });
        setSelected(prev => {
          const dum = { ...prev };
          dum[reverseStatus] = false;
          dum[status] = !dum[status];
          console.log(dum);
          return dum;
        });
      }}
      variant="soft"
      size="small"
      className={classes.pill}
      sx={{
        border:
          selected?.[status] &&
          `1px solid ${theme.palette.border.primaryAccent1} !important`,
        background:
          selected?.[status] &&
          `${theme.palette.background.primaryAccent2} !important`,
      }}
    >
      <Typography variant="caption">{label}</Typography>
    </Button>
  );
};

const ScreeningFilters = ({ FiltersMap, setFilterAPICode, reset }) => {
  // const dumSelected = {
  //     [SKILL_MATCH_QUALIFIED]: false,
  //     [SKILL_MATCH_NOT_QUALIFIED]: false
  // }

  const dumSelected = useMemo(() => {
    const obj = {
      [SKILL_MATCH_QUALIFIED]: false,
      [SKILL_MATCH_NOT_QUALIFIED]: false,
    };
    return obj;
  }, []);

  if (FiltersMap?.screening_preferred_criteria) {
    Object.keys(FiltersMap?.screening_preferred_criteria)?.forEach(item => {
      dumSelected[`CRITERIA_QUALIFIED_${item}`] = false;
      dumSelected[`CRITERIA_NOT_QUALIFIED_${item}`] = false;
    });
  }
  const [selected, setSelected] = useState(dumSelected);

  useEffect(() => {
    setSelected(dumSelected);
  }, [dumSelected, reset]);

  return (
    <>
      {FiltersMap?.screening_skills && (
        <Stack spacing="12px">
          <Typography variant="input" sx={{ fontWeight: 500 }}>
            Primary skill (skill)
          </Typography>
          <Stack spacing="8px" direction="row" sx={{ marginBottom: '0px' }}>
            <Pill
              selected={selected}
              setSelected={setSelected}
              status={SKILL_MATCH_QUALIFIED}
              reverseStatus={SKILL_MATCH_NOT_QUALIFIED}
              label={`Qualified (${FiltersMap?.screening_skills?.total_qualified})`}
              setFilterAPICode={setFilterAPICode}
              FiltersMap={FiltersMap}
            />
            <Pill
              selected={selected}
              setSelected={setSelected}
              status={SKILL_MATCH_NOT_QUALIFIED}
              reverseStatus={SKILL_MATCH_QUALIFIED}
              label={`Disqualified (${FiltersMap?.screening_skills?.total_not_qualified})`}
              setFilterAPICode={setFilterAPICode}
              FiltersMap={FiltersMap}
            />
          </Stack>
          {/* <Stack spacing="8px">
                        <FormControlLabel control={<Checkbox onChange={() => { const dumstr = `PRESCREENING_QUALIFIED_${item?.text}`; setFilterAPICode({ ...filterAPICode, [FiltersMap?.filter_codes[dumstr]]: 1 }) }} />} label={`Qualified (${FiltersMap?.screening_skills?.total_qualified})`} />
                        <FormControlLabel control={<Checkbox />} label={`Disqualified (${FiltersMap?.screening_skills?.total_not_qualified})`} />
                    </Stack> */}
        </Stack>
      )}

      {FiltersMap?.screening_preferred_criteria &&
        Object.values(FiltersMap?.screening_preferred_criteria)?.map(
          (item, index) => {
            const text = Object.keys(
              FiltersMap?.screening_preferred_criteria,
            )?.[index];
            return (
              <Stack spacing="12px" key={index}>
                <Typography variant="input" sx={{ fontWeight: 500 }}>
                  {text}
                </Typography>
                <Stack
                  spacing="8px"
                  direction="row"
                  sx={{ marginBottom: '0px' }}
                >
                  <Pill
                    selected={selected}
                    setSelected={setSelected}
                    status={`CRITERIA_QUALIFIED_${text}`}
                    reverseStatus={`CRITERIA_NOT_QUALIFIED_${text}`}
                    label={`Qualified (${item?.total_qualified})`}
                    setFilterAPICode={setFilterAPICode}
                    FiltersMap={FiltersMap}
                  />
                  <Pill
                    selected={selected}
                    setSelected={setSelected}
                    status={`CRITERIA_NOT_QUALIFIED_${text}`}
                    reverseStatus={`CRITERIA_QUALIFIED_${text}`}
                    label={`Disqualified (${item?.total_not_qualified})`}
                    setFilterAPICode={setFilterAPICode}
                    FiltersMap={FiltersMap}
                  />
                </Stack>

                {/* <Stack spacing="8px">
                            <FormControlLabel control={<Checkbox />} label={`Qualified (${item?.total_qualified})`} />
                            <FormControlLabel control={<Checkbox />} label={`Disqualified (${item?.total_not_qualified})`} />
                        </Stack> */}
              </Stack>
            );
          },
        )}
    </>
  );
};
export default ScreeningFilters;
